

import $, { readyException } from "jquery";


import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


const weAreCoWorkersTop = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error("Element not found for Swiper initialization [WeAreCoWorkersTop-Swiper]");
    }
    let topSplide = new Splide(el,
        {
            autoScroll: {
            speed: 1,
            },
            type: 'loop',
            autoHeight: true,
            autoWidth: true,
            cloneStatus: false,
            pagination: false,
            arrows: false,
            updateOnMove: true,
            gap: '2.4rem',
        }
    ).mount({ AutoScroll });

};

export default weAreCoWorkersTop;






